const revealScrollDurationMs = 800;

const heroIntroKenBurnsMs = 5000;
const heroIntroRevealDelayMs = 1400;
const heroIntroRevealDurationMs = 700;

const navRevealOffset = 50;
const root = document.documentElement;
const homeHero = document.querySelector(".hero--home");
const mainContent = document.getElementById("main-content");

const getScrollTargetTop = (element) => {
  const scrollMarginTop =
    Number.parseFloat(getComputedStyle(element).scrollMarginTop) || 0;

  return Math.max(
    0,
    Math.round(
      element.getBoundingClientRect().top + window.scrollY - scrollMarginTop,
    ),
  );
};

const getMainContentScrollTop = () => {
  if (!mainContent) {
    return 0;
  }

  return getScrollTargetTop(mainContent);
};

const easeOutCubic = (progress) => 1 - (1 - progress) ** 3;

const animateScrollTo = (targetY, durationMs, onStep) => {
  const startY = window.scrollY;
  const distance = targetY - startY;

  if (distance === 0 || durationMs <= 0) {
    window.scrollTo(0, targetY);
    onStep?.();
    return;
  }

  const startTime = performance.now();

  const tick = (now) => {
    const progress = Math.min((now - startTime) / durationMs, 1);

    window.scrollTo(0, startY + distance * easeOutCubic(progress));
    onStep?.();

    if (progress < 1) {
      requestAnimationFrame(tick);
    }
  };

  requestAnimationFrame(tick);
};

if (homeHero) {
  root.style.setProperty(
    "--home-hero-reveal-duration",
    `${revealScrollDurationMs}ms`,
  );
  root.style.setProperty(
    "--hero-intro-ken-burns-duration",
    `${heroIntroKenBurnsMs}ms`,
  );
  root.style.setProperty(
    "--hero-intro-reveal-delay",
    `${heroIntroRevealDelayMs}ms`,
  );
  root.style.setProperty(
    "--hero-intro-reveal-duration",
    `${heroIntroRevealDurationMs}ms`,
  );

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  const startHeroIntro = () => {
    if (prefersReducedMotion || window.scrollY > 0) {
      root.classList.add("is-home-hero-intro-done");
      return;
    }

    root.classList.add("is-home-hero-intro-active");

    const introTotalMs = Math.max(
      heroIntroKenBurnsMs,
      heroIntroRevealDelayMs + heroIntroRevealDurationMs,
    );

    window.setTimeout(() => {
      root.classList.remove("is-home-hero-intro-active");
      root.classList.add("is-home-hero-intro-done");
    }, introTotalMs);
  };

  startHeroIntro();

  const revealButton = homeHero.querySelector("[data-home-hero-reveal]");
  const revealIntroDoneMs = heroIntroRevealDelayMs + heroIntroRevealDurationMs;

  const markRevealReady = () => {
    root.classList.add("is-home-hero-reveal-ready");
  };

  if (revealButton && !prefersReducedMotion) {
    revealButton.addEventListener("animationend", (event) => {
      if (event.animationName === "hero-reveal-btn-in") {
        markRevealReady();
      }
    });

    window.setTimeout(markRevealReady, revealIntroDoneMs);
  } else if (revealButton) {
    markRevealReady();
  }

  const syncNavVisible = () => {
    root.classList.toggle(
      "is-home-nav-visible",
      window.scrollY > navRevealOffset,
    );
  };

  const syncRevealHidden = () => {
    const shouldHide = window.scrollY > navRevealOffset;

    if (shouldHide) {
      markRevealReady();
    }

    root.classList.toggle("is-home-reveal-hidden", shouldHide);
  };

  const syncLogoHidden = () => {
    root.classList.toggle(
      "is-home-logo-hidden",
      window.scrollY > navRevealOffset,
    );
  };

  const syncScrollState = () => {
    syncNavVisible();
    syncRevealHidden();
    syncLogoHidden();
  };

  const reveal = () => {
    root.classList.remove("is-home-hero-intro-active");
    root.classList.add("is-home-hero-intro-done");
    markRevealReady();
    syncScrollState();

    if (mainContent) {
      const target = getMainContentScrollTop();

      if (window.scrollY < target) {
        if (prefersReducedMotion) {
          window.scrollTo(0, target);
          syncScrollState();
        } else {
          animateScrollTo(target, revealScrollDurationMs, syncScrollState);
        }
      }
    }
  };

  revealButton?.addEventListener("click", reveal);

  revealButton?.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      reveal();
    }
  });

  syncScrollState();

  window.addEventListener("scroll", syncScrollState, { passive: true });

  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) {
      return;
    }

    root.classList.remove(
      "is-home-hero-intro-active",
      "is-home-hero-intro-done",
      "is-home-hero-reveal-ready",
      "is-home-nav-visible",
      "is-home-reveal-hidden",
      "is-home-logo-hidden",
    );
    startHeroIntro();
    syncScrollState();
  });
}
